import Command from './_Command';

export default class CustomButtonGroupController extends Command {
    constructor(public readonly Key: string) {
        super({
            Enabled: true,
            Key,
            Path: false,
            Callback: () => {
                return;
            },
        });
    }
}
